import { showMessages } from '@intercom/messenger-js-sdk';
import { Button } from '@synoptic/ui-kit/button/button.js';
import { ChatBubbleEmptyIcon } from '@synoptic/ui-kit/icons/react/chat-bubble-empty.js';
import clsx from 'clsx';
import { menuItemButton, menuItemText } from './menu-action.css';

export const ReportMenuAction = function ReportMenuAction({
  ref,
  className,
}: { className?: string } & {
  ref?: React.Ref<HTMLButtonElement>;
}) {
  return (
    <Button
      ref={ref}
      className={clsx(menuItemButton, className)}
      startIcon={<ChatBubbleEmptyIcon />}
      variant="ghost"
      onClick={() => {
        showMessages();
      }}
    >
      <span className={menuItemText}>Contact us</span>
    </Button>
  );
};
